import {Dialog, DialogActions, DialogContent, DialogTitle, Grid} from "@material-ui/core"
import React from "react"
import {injectIntl} from "react-intl"
import XsButton from "../../global/ui/xsButton/xsButton"
import {observer} from "mobx-react"
import WarningDialogStore from "./WarningDialogStore"

function WarningDialog() {
	return (
		<Dialog
			id="warningDialog"
			open={WarningDialogStore.isOpen}
			onClose={() => WarningDialogStore.close()}
			className="xs-base-dialog"
			classes={{
				paper: "xs-paper-dialog xs-width-paper-600 fullWidth"
			}}
			disableBackdropClick={true}
			maxWidth="md"
		>
			<DialogTitle className="xs-warning bgAmberWarning" style={{borderTopLeftRadius: 4, borderTopRightRadius: 4}}>
				<div className="xs-header">
					<div
						style={{position: "absolute", right: 24, top: 16, cursor: "pointer"}}
						onClick={() => {
							WarningDialogStore.close()
						}}
					>
						<i className="fal fa-times fa-lg white" />
					</div>
					<Grid container justify="center" className="white" spacing={2} alignItems="center">
						<Grid item>
							<i className="fal fa-exclamation-triangle fa-2x"></i>
						</Grid>
						<Grid item>
							<div className="xs-header-title">Upozornenie</div>
						</Grid>
					</Grid>
				</div>
			</DialogTitle>
			<DialogContent>
				<Grid container tex className="pl-2 pt-4">
					<Grid item xs={12} className="pt-4">
						{WarningDialogStore.message}
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Grid item container justify="flex-end" className="ma-4">
					<Grid item>
						<XsButton
							style={{backgroundColor: "#ffb900"}}
							icon={<i className="fal fa-check" />}
							text="OK"
							onClick={() => WarningDialogStore.close()}
						/>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	)
}

export default injectIntl(observer(WarningDialog))

